import { cn } from '@/lib/utils';

const CLUB_COLORS: Record<string, { primary: string; secondary: string }> = {
  'Arsenal': { primary: '#EF0107', secondary: '#FFFFFF' },
  'Aston Villa': { primary: '#670E36', secondary: '#95BFE5' },
  'AFC Bournemouth': { primary: '#DA291C', secondary: '#000000' },
  'Brentford': { primary: '#E30613', secondary: '#FBB800' },
  'Brighton & Hove Albion': { primary: '#0057B8', secondary: '#FFFFFF' },
  'Chelsea': { primary: '#034694', secondary: '#FFFFFF' },
  'Crystal Palace': { primary: '#1B458F', secondary: '#C4122E' },
  'Everton': { primary: '#003399', secondary: '#FFFFFF' },
  'Fulham': { primary: '#000000', secondary: '#FFFFFF' },
  'Ipswich Town': { primary: '#0044AA', secondary: '#FFFFFF' },
  'Leicester City': { primary: '#003090', secondary: '#FDBE11' },
  'Liverpool': { primary: '#C8102E', secondary: '#FFFFFF' },
  'Manchester City': { primary: '#6CABDD', secondary: '#1C2C5B' },
  'Manchester United': { primary: '#DA291C', secondary: '#FBE122' },
  'Newcastle United': { primary: '#241F20', secondary: '#FFFFFF' },
  'Nottingham Forest': { primary: '#DD0000', secondary: '#FFFFFF' },
  'Southampton': { primary: '#D71920', secondary: '#FFFFFF' },
  'Tottenham Hotspur': { primary: '#132257', secondary: '#FFFFFF' },
  'West Ham United': { primary: '#7A263A', secondary: '#1BB1E7' },
  'Wolverhampton Wanderers': { primary: '#FDB913', secondary: '#231F20' },
  'Wolves': { primary: '#FDB913', secondary: '#231F20' },
  'RCD Mallorca': { primary: '#E20613', secondary: '#000000' },
  'Mallorca': { primary: '#E20613', secondary: '#000000' },
  // La Liga
  'Real Madrid': { primary: '#FFFFFF', secondary: '#FEBE10' },
  'Barcelona': { primary: '#A50044', secondary: '#004D98' },
  'Atlético Madrid': { primary: '#CB3524', secondary: '#FFFFFF' },
  'Atletico Madrid': { primary: '#CB3524', secondary: '#FFFFFF' },
  'Real Sociedad': { primary: '#003DA5', secondary: '#FFFFFF' },
  'Real Betis': { primary: '#00954C', secondary: '#FFFFFF' },
  'Villarreal': { primary: '#FFE114', secondary: '#005187' },
  'Athletic Bilbao': { primary: '#EE2523', secondary: '#FFFFFF' },
  'Athletic Club': { primary: '#EE2523', secondary: '#FFFFFF' },
  'Sevilla': { primary: '#D4021D', secondary: '#FFFFFF' },
  'Sevilla FC': { primary: '#D4021D', secondary: '#FFFFFF' },
  'Valencia': { primary: '#EE3524', secondary: '#000000' },
  'Valencia CF': { primary: '#EE3524', secondary: '#000000' },
  'Osasuna': { primary: '#D91A2A', secondary: '#0A1E5C' },
  'CA Osasuna': { primary: '#D91A2A', secondary: '#0A1E5C' },
  'Celta Vigo': { primary: '#8AC3EE', secondary: '#FFFFFF' },
  'RC Celta': { primary: '#8AC3EE', secondary: '#FFFFFF' },
  'Getafe': { primary: '#004FA3', secondary: '#FFFFFF' },
  'Getafe CF': { primary: '#004FA3', secondary: '#FFFFFF' },
  'Rayo Vallecano': { primary: '#E53027', secondary: '#FFFFFF' },
  'Girona': { primary: '#CD2534', secondary: '#FFFFFF' },
  'Girona FC': { primary: '#CD2534', secondary: '#FFFFFF' },
  'Alavés': { primary: '#003DA5', secondary: '#FFFFFF' },
  'Deportivo Alavés': { primary: '#003DA5', secondary: '#FFFFFF' },
  'Las Palmas': { primary: '#FFE400', secondary: '#0053A0' },
  'UD Las Palmas': { primary: '#FFE400', secondary: '#0053A0' },
  'Espanyol': { primary: '#007FC8', secondary: '#FFFFFF' },
  'RCD Espanyol': { primary: '#007FC8', secondary: '#FFFFFF' },
  'Real Valladolid': { primary: '#691B68', secondary: '#FFFFFF' },
  'Valladolid': { primary: '#691B68', secondary: '#FFFFFF' },
  'Leganés': { primary: '#003DA5', secondary: '#FFFFFF' },
  'CD Leganés': { primary: '#003DA5', secondary: '#FFFFFF' },
  'Real Betis Balompié': { primary: '#00954C', secondary: '#FFFFFF' },
  // Bundesliga
  'Bayern Munich': { primary: '#DC052D', secondary: '#0066B2' },
  'FC Bayern München': { primary: '#DC052D', secondary: '#0066B2' },
  'Bayern München': { primary: '#DC052D', secondary: '#0066B2' },
  'Borussia Dortmund': { primary: '#FDE100', secondary: '#000000' },
  'Bayer Leverkusen': { primary: '#E32221', secondary: '#000000' },
  'Bayer 04 Leverkusen': { primary: '#E32221', secondary: '#000000' },
  'RB Leipzig': { primary: '#DD0741', secondary: '#FFFFFF' },
  'Eintracht Frankfurt': { primary: '#E1000F', secondary: '#000000' },
  'VfB Stuttgart': { primary: '#E32219', secondary: '#FFFFFF' },
  'Stuttgart': { primary: '#E32219', secondary: '#FFFFFF' },
  'SC Freiburg': { primary: '#000000', secondary: '#E2001A' },
  'Freiburg': { primary: '#000000', secondary: '#E2001A' },
  'TSG Hoffenheim': { primary: '#1961B5', secondary: '#FFFFFF' },
  'Hoffenheim': { primary: '#1961B5', secondary: '#FFFFFF' },
  'VfL Wolfsburg': { primary: '#65B32E', secondary: '#FFFFFF' },
  'Wolfsburg': { primary: '#65B32E', secondary: '#FFFFFF' },
  'Borussia Mönchengladbach': { primary: '#000000', secondary: '#FFFFFF' },
  'Mönchengladbach': { primary: '#000000', secondary: '#FFFFFF' },
  '1. FC Union Berlin': { primary: '#EB1923', secondary: '#FDE100' },
  'Union Berlin': { primary: '#EB1923', secondary: '#FDE100' },
  'SV Werder Bremen': { primary: '#1D9053', secondary: '#FFFFFF' },
  'Werder Bremen': { primary: '#1D9053', secondary: '#FFFFFF' },
  'FC Augsburg': { primary: '#BA3733', secondary: '#00572C' },
  'Augsburg': { primary: '#BA3733', secondary: '#00572C' },
  '1. FSV Mainz 05': { primary: '#C3002F', secondary: '#FFFFFF' },
  'Mainz 05': { primary: '#C3002F', secondary: '#FFFFFF' },
  'Mainz': { primary: '#C3002F', secondary: '#FFFFFF' },
  '1. FC Heidenheim': { primary: '#E30613', secondary: '#003DA5' },
  'Heidenheim': { primary: '#E30613', secondary: '#003DA5' },
  'FC St. Pauli': { primary: '#6E4B3A', secondary: '#FFFFFF' },
  'St. Pauli': { primary: '#6E4B3A', secondary: '#FFFFFF' },
  'Holstein Kiel': { primary: '#003DA5', secondary: '#E30613' },
  'Kiel': { primary: '#003DA5', secondary: '#E30613' },
  // Serie A
  'Juventus': { primary: '#000000', secondary: '#FFFFFF' },
  'Inter Milan': { primary: '#010E80', secondary: '#000000' },
  'Internazionale': { primary: '#010E80', secondary: '#000000' },
  'AC Milan': { primary: '#FB090B', secondary: '#000000' },
  'Milan': { primary: '#FB090B', secondary: '#000000' },
  'Napoli': { primary: '#12A0D7', secondary: '#FFFFFF' },
  'SSC Napoli': { primary: '#12A0D7', secondary: '#FFFFFF' },
  'AS Roma': { primary: '#8E1F2F', secondary: '#F0BC42' },
  'Roma': { primary: '#8E1F2F', secondary: '#F0BC42' },
  'Lazio': { primary: '#87D8F7', secondary: '#FFFFFF' },
  'SS Lazio': { primary: '#87D8F7', secondary: '#FFFFFF' },
  'Atalanta': { primary: '#1E71B8', secondary: '#000000' },
  'Fiorentina': { primary: '#482B80', secondary: '#FFFFFF' },
  'ACF Fiorentina': { primary: '#482B80', secondary: '#FFFFFF' },
  'Bologna': { primary: '#1A2F48', secondary: '#A21C26' },
  'Bologna FC': { primary: '#1A2F48', secondary: '#A21C26' },
  'Torino': { primary: '#8B0000', secondary: '#FFFFFF' },
  'Torino FC': { primary: '#8B0000', secondary: '#FFFFFF' },
  'Monza': { primary: '#ED1C24', secondary: '#FFFFFF' },
  'AC Monza': { primary: '#ED1C24', secondary: '#FFFFFF' },
  'Genoa': { primary: '#A41E2C', secondary: '#1A3A6D' },
  'Genoa CFC': { primary: '#A41E2C', secondary: '#1A3A6D' },
  'Udinese': { primary: '#000000', secondary: '#FFFFFF' },
  'Udinese Calcio': { primary: '#000000', secondary: '#FFFFFF' },
  'Cagliari': { primary: '#9E1B32', secondary: '#003DA5' },
  'Cagliari Calcio': { primary: '#9E1B32', secondary: '#003DA5' },
  'Empoli': { primary: '#005BA6', secondary: '#FFFFFF' },
  'Empoli FC': { primary: '#005BA6', secondary: '#FFFFFF' },
  'Parma': { primary: '#FEDD00', secondary: '#003DA5' },
  'Parma Calcio': { primary: '#FEDD00', secondary: '#003DA5' },
  'Como': { primary: '#003DA5', secondary: '#FFFFFF' },
  'Como 1907': { primary: '#003DA5', secondary: '#FFFFFF' },
  'Hellas Verona': { primary: '#003DA5', secondary: '#FEDD00' },
  'Verona': { primary: '#003DA5', secondary: '#FEDD00' },
  'Venezia': { primary: '#FF6600', secondary: '#004D40' },
  'Venezia FC': { primary: '#FF6600', secondary: '#004D40' },
  'Lecce': { primary: '#FFD700', secondary: '#E30613' },
  'US Lecce': { primary: '#FFD700', secondary: '#E30613' },
  // Ligue 1
  'Paris Saint-Germain': { primary: '#004170', secondary: '#DA291C' },
  'PSG': { primary: '#004170', secondary: '#DA291C' },
  'Olympique de Marseille': { primary: '#2FAEE0', secondary: '#FFFFFF' },
  'Marseille': { primary: '#2FAEE0', secondary: '#FFFFFF' },
  'AS Monaco': { primary: '#E7192E', secondary: '#FFFFFF' },
  'Monaco': { primary: '#E7192E', secondary: '#FFFFFF' },
  'Olympique Lyonnais': { primary: '#1A3C8E', secondary: '#ED1C24' },
  'Lyon': { primary: '#1A3C8E', secondary: '#ED1C24' },
  'LOSC Lille': { primary: '#E30613', secondary: '#FFFFFF' },
  'Lille': { primary: '#E30613', secondary: '#FFFFFF' },
  'OGC Nice': { primary: '#000000', secondary: '#E30613' },
  'Nice': { primary: '#000000', secondary: '#E30613' },
  'RC Lens': { primary: '#FFD700', secondary: '#E30613' },
  'Lens': { primary: '#FFD700', secondary: '#E30613' },
  'Stade Rennais': { primary: '#E30613', secondary: '#000000' },
  'Rennes': { primary: '#E30613', secondary: '#000000' },
  'RC Strasbourg': { primary: '#005BA6', secondary: '#FFFFFF' },
  'Strasbourg': { primary: '#005BA6', secondary: '#FFFFFF' },
  'Stade de Reims': { primary: '#E30613', secondary: '#FFFFFF' },
  'Reims': { primary: '#E30613', secondary: '#FFFFFF' },
  'Toulouse FC': { primary: '#6A2382', secondary: '#FFFFFF' },
  'Toulouse': { primary: '#6A2382', secondary: '#FFFFFF' },
  'Montpellier HSC': { primary: '#003DA5', secondary: '#FF6900' },
  'Montpellier': { primary: '#003DA5', secondary: '#FF6900' },
  'Stade Brestois': { primary: '#E30613', secondary: '#FFFFFF' },
  'Brest': { primary: '#E30613', secondary: '#FFFFFF' },
  'FC Nantes': { primary: '#FCD209', secondary: '#00A551' },
  'Nantes': { primary: '#FCD209', secondary: '#00A551' },
  'AJ Auxerre': { primary: '#004A9F', secondary: '#FFFFFF' },
  'Auxerre': { primary: '#004A9F', secondary: '#FFFFFF' },
  'Angers SCO': { primary: '#000000', secondary: '#FFFFFF' },
  'Angers': { primary: '#000000', secondary: '#FFFFFF' },
  'AS Saint-Étienne': { primary: '#00754B', secondary: '#FFFFFF' },
  'Saint-Étienne': { primary: '#00754B', secondary: '#FFFFFF' },
  'Le Havre AC': { primary: '#004A99', secondary: '#87CEEB' },
  'Le Havre': { primary: '#004A99', secondary: '#87CEEB' },
  // Primeira Liga
  'SL Benfica': { primary: '#E20615', secondary: '#FFFFFF' },
  'Benfica': { primary: '#E20615', secondary: '#FFFFFF' },
  'Sporting CP': { primary: '#006B38', secondary: '#FFFFFF' },
  'Sporting': { primary: '#006B38', secondary: '#FFFFFF' },
  'FC Porto': { primary: '#003DA5', secondary: '#FFFFFF' },
  'Porto': { primary: '#003DA5', secondary: '#FFFFFF' },
  'SC Braga': { primary: '#ED1C24', secondary: '#FFFFFF' },
  'Braga': { primary: '#ED1C24', secondary: '#FFFFFF' },
  'Vitória SC': { primary: '#000000', secondary: '#FFFFFF' },
  'Casa Pia AC': { primary: '#005A32', secondary: '#FFFFFF' },
  'Moreirense FC': { primary: '#006B3F', secondary: '#FFFFFF' },
  'Rio Ave FC': { primary: '#006633', secondary: '#FFFFFF' },
  'Gil Vicente FC': { primary: '#E30613', secondary: '#003DA5' },
  'Boavista FC': { primary: '#000000', secondary: '#FFFFFF' },
  'FC Famalicão': { primary: '#003DA5', secondary: '#FFFFFF' },
  'FC Arouca': { primary: '#FFD700', secondary: '#000000' },
  'Estrela da Amadora': { primary: '#E30613', secondary: '#000000' },
  'FC Vizela': { primary: '#003DA5', secondary: '#FFFFFF' },
  'Portimonense SC': { primary: '#000000', secondary: '#FFD700' },
  'GD Chaves': { primary: '#E30613', secondary: '#003DA5' },
  'CD Nacional': { primary: '#000000', secondary: '#FFFFFF' },
  'Estoril Praia': { primary: '#FFD700', secondary: '#003DA5' },
  // Eredivisie
  'Ajax': { primary: '#CF0032', secondary: '#FFFFFF' },
  'PSV Eindhoven': { primary: '#ED1C24', secondary: '#FFFFFF' },
  'PSV': { primary: '#ED1C24', secondary: '#FFFFFF' },
  'Feyenoord': { primary: '#ED1C24', secondary: '#000000' },
  'AZ Alkmaar': { primary: '#ED1C24', secondary: '#FFFFFF' },
  'AZ': { primary: '#ED1C24', secondary: '#FFFFFF' },
  'FC Twente': { primary: '#E30613', secondary: '#FFFFFF' },
  'FC Utrecht': { primary: '#E30613', secondary: '#FFFFFF' },
  'Sparta Rotterdam': { primary: '#E30613', secondary: '#FFFFFF' },
  'Go Ahead Eagles': { primary: '#E30613', secondary: '#FFD700' },
  'SC Heerenveen': { primary: '#003DA5', secondary: '#FFFFFF' },
  'NEC Nijmegen': { primary: '#E30613', secondary: '#00A651' },
  'NEC': { primary: '#E30613', secondary: '#00A651' },
  'Fortuna Sittard': { primary: '#00A651', secondary: '#FFD700' },
  'FC Groningen': { primary: '#00A651', secondary: '#FFFFFF' },
  'RKC Waalwijk': { primary: '#FFD700', secondary: '#003DA5' },
  'PEC Zwolle': { primary: '#003DA5', secondary: '#FFFFFF' },
  'FC Volendam': { primary: '#FF6600', secondary: '#000000' },
  'Vitesse': { primary: '#FFD700', secondary: '#000000' },
  'Willem II': { primary: '#E30613', secondary: '#003DA5' },
  'Heracles Almelo': { primary: '#000000', secondary: '#FFFFFF' },
  'Heracles': { primary: '#000000', secondary: '#FFFFFF' },
  'NAC Breda': { primary: '#FFD700', secondary: '#00A651' },
  // Bundesliga (additional)
  '1. FC Köln': { primary: '#ED1C24', secondary: '#FFFFFF' },
  'SV Darmstadt 98': { primary: '#005BAC', secondary: '#FFFFFF' },
  // Serie A (additional)
  'Atalanta BC': { primary: '#1E71B8', secondary: '#000000' },
  'US Sassuolo': { primary: '#00A651', secondary: '#000000' },
  'Frosinone Calcio': { primary: '#FFD700', secondary: '#003DA5' },
  // Ligue 1 (additional)
  'Lille OSC': { primary: '#E30613', secondary: '#FFFFFF' },
  'Clermont Foot': { primary: '#E30613', secondary: '#003DA5' },
  'FC Lorient': { primary: '#FF6600', secondary: '#000000' },
  // La Liga (Barcelona canonical)
  'FC Barcelona': { primary: '#A50044', secondary: '#004D98' },
  // Süper Lig (Turkey)
  'Galatasaray': { primary: '#FBB800', secondary: '#A90432' },
  'Fenerbahçe': { primary: '#003DA5', secondary: '#FFED00' },
  'Beşiktaş': { primary: '#000000', secondary: '#FFFFFF' },
  'Trabzonspor': { primary: '#7B1E2E', secondary: '#87CEEB' },
  'İstanbul Başakşehir': { primary: '#F47A1F', secondary: '#003DA5' },
  'Adana Demirspor': { primary: '#003DA5', secondary: '#FFFFFF' },
  'Alanyaspor': { primary: '#FF6600', secondary: '#00A651' },
  'Antalyaspor': { primary: '#E30613', secondary: '#FFFFFF' },
  'Çaykur Rizespor': { primary: '#00A651', secondary: '#FFFFFF' },
  'Fatih Karagümrük': { primary: '#E30613', secondary: '#000000' },
  'Gaziantep FK': { primary: '#E30613', secondary: '#000000' },
  'Hatayspor': { primary: '#A50044', secondary: '#FFFFFF' },
  'İstanbulspor': { primary: '#FFD700', secondary: '#000000' },
  'Kasımpaşa': { primary: '#003DA5', secondary: '#FFFFFF' },
  'Kayserispor': { primary: '#FFD700', secondary: '#E30613' },
  'Konyaspor': { primary: '#00A651', secondary: '#FFFFFF' },
  'Pendikspor': { primary: '#7B1E2E', secondary: '#FFFFFF' },
  'Samsunspor': { primary: '#E30613', secondary: '#FFFFFF' },
  'Sivasspor': { primary: '#E30613', secondary: '#FFFFFF' },
  // Greek Super League
  'Olympiacos': { primary: '#E30613', secondary: '#FFFFFF' },
  'Panathinaikos': { primary: '#00754B', secondary: '#FFFFFF' },
  'PAOK': { primary: '#000000', secondary: '#FFFFFF' },
  'AEK Athens': { primary: '#FFD700', secondary: '#000000' },
  'Aris Thessaloniki': { primary: '#FFD700', secondary: '#000000' },
  'Asteras Tripolis': { primary: '#FFD700', secondary: '#003DA5' },
  'Atromitos': { primary: '#003DA5', secondary: '#FFFFFF' },
  'Kifisia': { primary: '#003DA5', secondary: '#FFD700' },
  'Lamia': { primary: '#003DA5', secondary: '#FFFFFF' },
  'Levadiakos': { primary: '#00A651', secondary: '#FFFFFF' },
  'OFI Crete': { primary: '#000000', secondary: '#FFFFFF' },
  'Panaitolikos': { primary: '#E30613', secondary: '#FFFFFF' },
  'Volos NFC': { primary: '#003DA5', secondary: '#E30613' },
  // Belgian Pro League
  'Anderlecht': { primary: '#7A0026', secondary: '#FFFFFF' },
  'Club Brugge': { primary: '#003DA5', secondary: '#000000' },
  'Cercle Brugge': { primary: '#00A651', secondary: '#000000' },
  'Genk': { primary: '#003DA5', secondary: '#FFFFFF' },
  'Gent': { primary: '#003DA5', secondary: '#FFFFFF' },
  'Antwerp': { primary: '#E30613', secondary: '#FFFFFF' },
  'Standard Liège': { primary: '#E30613', secondary: '#FFFFFF' },
  'Charleroi': { primary: '#000000', secondary: '#FFFFFF' },
  'Mechelen': { primary: '#FFD700', secondary: '#E30613' },
  'Kortrijk': { primary: '#E30613', secondary: '#FFFFFF' },
  'Sint-Truiden': { primary: '#FFD700', secondary: '#000000' },
  'OH Leuven': { primary: '#003DA5', secondary: '#FFFFFF' },
  'Westerlo': { primary: '#FFD700', secondary: '#003DA5' },
  'Union Saint-Gilloise': { primary: '#FFD700', secondary: '#003DA5' },
  'Beerschot': { primary: '#7A0026', secondary: '#FFFFFF' },
  'Dender': { primary: '#FFD700', secondary: '#000000' },
  // Czech Fortuna Liga
  'Slavia Praha': { primary: '#A50044', secondary: '#FFFFFF' },
  'Sparta Praha': { primary: '#7A263A', secondary: '#FFD700' },
  'Viktoria Plzeň': { primary: '#003DA5', secondary: '#E30613' },
  'Baník Ostrava': { primary: '#003DA5', secondary: '#FFFFFF' },
  'Sigma Olomouc': { primary: '#003DA5', secondary: '#FFFFFF' },
  'Slovácko': { primary: '#003DA5', secondary: '#FFFFFF' },
  'Mladá Boleslav': { primary: '#003DA5', secondary: '#FFFFFF' },
  'Slovan Liberec': { primary: '#003DA5', secondary: '#FFFFFF' },
  'Bohemians 1905': { primary: '#00A651', secondary: '#FFFFFF' },
  'Jablonec': { primary: '#00A651', secondary: '#FFD700' },
  'Hradec Králové': { primary: '#003DA5', secondary: '#FFFFFF' },
  'Teplice': { primary: '#FFD700', secondary: '#003DA5' },
  'Pardubice': { primary: '#E30613', secondary: '#FFFFFF' },
  'Karviná': { primary: '#003DA5', secondary: '#E30613' },
  'Dukla Praha': { primary: '#7A0026', secondary: '#FFD700' },
  'České Budějovice': { primary: '#000000', secondary: '#FFFFFF' },
  // Slovak Niké Liga
  'Slovan Bratislava': { primary: '#003DA5', secondary: '#FFFFFF' },
  'Spartak Trnava': { primary: '#E30613', secondary: '#000000' },
  'MŠK Žilina': { primary: '#FFD700', secondary: '#00A651' },
  'DAC Dunajská Streda': { primary: '#FFD700', secondary: '#003DA5' },
  'AS Trenčín': { primary: '#E30613', secondary: '#FFFFFF' },
  'MFK Ružomberok': { primary: '#E30613', secondary: '#FFFFFF' },
  'MFK Skalica': { primary: '#003DA5', secondary: '#FFFFFF' },
  'FC Košice': { primary: '#FFD700', secondary: '#003DA5' },
  'Dukla Banská Bystrica': { primary: '#7A0026', secondary: '#FFFFFF' },
  'FK Železiarne Podbrezová': { primary: '#00A651', secondary: '#FFFFFF' },
  // Croatian HNL
  'Dinamo Zagreb': { primary: '#003DA5', secondary: '#FFFFFF' },
  'Hajduk Split': { primary: '#003DA5', secondary: '#FFFFFF' },
  'Rijeka': { primary: '#FFFFFF', secondary: '#000000' },
  'Osijek': { primary: '#003DA5', secondary: '#FFFFFF' },
  'Lokomotiva Zagreb': { primary: '#003DA5', secondary: '#FFFFFF' },
  'Slaven Belupo': { primary: '#003DA5', secondary: '#FFD700' },
  'Varaždin': { primary: '#003DA5', secondary: '#FFFFFF' },
  'Istra 1961': { primary: '#00A651', secondary: '#FFD700' },
  'Šibenik': { primary: '#003DA5', secondary: '#FFFFFF' },
  'Gorica': { primary: '#003DA5', secondary: '#FFD700' },
  // Serbian SuperLiga
  'FK Crvena Zvezda': { primary: '#E30613', secondary: '#FFFFFF' },
  'FK Partizan': { primary: '#000000', secondary: '#FFFFFF' },
  'FK Vojvodina': { primary: '#E30613', secondary: '#FFFFFF' },
  'FK TSC Bačka Topola': { primary: '#FFD700', secondary: '#003DA5' },
  'FK Čukarički': { primary: '#000000', secondary: '#FFD700' },
  'FK Radnički Niš': { primary: '#E30613', secondary: '#FFFFFF' },
  'FK Spartak Subotica': { primary: '#003DA5', secondary: '#FFD700' },
  'FK Novi Pazar': { primary: '#00A651', secondary: '#FFFFFF' },
  'FK Napredak Kruševac': { primary: '#7A0026', secondary: '#FFFFFF' },
  'FK Mladost GAT': { primary: '#003DA5', secondary: '#FFFFFF' },
  'FK Voždovac': { primary: '#E30613', secondary: '#FFD700' },
  'FK IMT': { primary: '#003DA5', secondary: '#FFFFFF' },
  'FK Javor Ivanjica': { primary: '#00A651', secondary: '#FFFFFF' },
  'FK Radnik Surdulica': { primary: '#003DA5', secondary: '#FFFFFF' },
  'FK Železničar Pančevo': { primary: '#003DA5', secondary: '#FFFFFF' },
  // Ukrainian Premier League
  'Shakhtar Donetsk': { primary: '#FF6600', secondary: '#000000' },
  'Dynamo Kyiv': { primary: '#FFFFFF', secondary: '#003DA5' },
  'FC Zorya Luhansk': { primary: '#000000', secondary: '#FFFFFF' },
  'FC Vorskla Poltava': { primary: '#00A651', secondary: '#FFFFFF' },
  'FC Dnipro-1': { primary: '#003DA5', secondary: '#FFFFFF' },
  'FC Oleksandriya': { primary: '#003DA5', secondary: '#FFD700' },
  'FC Rukh Lviv': { primary: '#003DA5', secondary: '#FFD700' },
  'FC Lviv': { primary: '#003DA5', secondary: '#FFFFFF' },
  'FC Karpaty Lviv': { primary: '#00A651', secondary: '#FFFFFF' },
  'FC Kolos Kovalivka': { primary: '#FFD700', secondary: '#00A651' },
  'FC LNZ Cherkasy': { primary: '#003DA5', secondary: '#FFD700' },
  'FC Inhulets Petrove': { primary: '#003DA5', secondary: '#FFFFFF' },
  'FC Olimpik Donetsk': { primary: '#003DA5', secondary: '#FFD700' },
  'FC Mariupol': { primary: '#FFD700', secondary: '#003DA5' },
  'FC Metalist Kharkiv': { primary: '#FFD700', secondary: '#003DA5' },
  'FC Metalurh Zaporizhzhia': { primary: '#003DA5', secondary: '#FFD700' },
  'FC Desna Chernihiv': { primary: '#00A651', secondary: '#FFD700' },
  // Polish Ekstraklasa
  'Legia Warszawa': { primary: '#00754B', secondary: '#FFFFFF' },
  'Lech Poznań': { primary: '#003DA5', secondary: '#FFFFFF' },
  'Raków Częstochowa': { primary: '#7A0026', secondary: '#003DA5' },
  'Pogoń Szczecin': { primary: '#7A0026', secondary: '#003DA5' },
  'Jagiellonia Białystok': { primary: '#FFD700', secondary: '#7A0026' },
  'Śląsk Wrocław': { primary: '#00A651', secondary: '#FFFFFF' },
  'Cracovia': { primary: '#E30613', secondary: '#FFFFFF' },
  'Lechia Gdańsk': { primary: '#FFD700', secondary: '#00A651' },
  'Piast Gliwice': { primary: '#E30613', secondary: '#003DA5' },
  'Górnik Zabrze': { primary: '#003DA5', secondary: '#FFD700' },
  'Widzew Łódź': { primary: '#E30613', secondary: '#FFFFFF' },
  'Korona Kielce': { primary: '#FFD700', secondary: '#7A0026' },
  'Radomiak Radom': { primary: '#00A651', secondary: '#FFFFFF' },
  'Stal Mielec': { primary: '#003DA5', secondary: '#FFD700' },
  'Puszcza Niepołomice': { primary: '#00A651', secondary: '#FFFFFF' },
  'Warta Poznań': { primary: '#00A651', secondary: '#FFFFFF' },
  'Ruch Chorzów': { primary: '#003DA5', secondary: '#FFFFFF' },
  'Zagłębie Lubin': { primary: '#00A651', secondary: '#FFD700' },
  // Danish Superliga
  'FC Copenhagen': { primary: '#FFFFFF', secondary: '#003DA5' },
  'FC Midtjylland': { primary: '#000000', secondary: '#E30613' },
  'Brøndby IF': { primary: '#FFD700', secondary: '#003DA5' },
  'FC Nordsjælland': { primary: '#FFD700', secondary: '#000000' },
  'AGF Aarhus': { primary: '#FFFFFF', secondary: '#003DA5' },
  'OB Odense': { primary: '#7A0026', secondary: '#FFFFFF' },
  'Randers FC': { primary: '#003DA5', secondary: '#FFFFFF' },
  'Silkeborg IF': { primary: '#003DA5', secondary: '#FFD700' },
  'Viborg FF': { primary: '#00A651', secondary: '#FFFFFF' },
  'Lyngby BK': { primary: '#003DA5', secondary: '#FFFFFF' },
  'Hvidovre IF': { primary: '#E30613', secondary: '#FFFFFF' },
  // Swedish Allsvenskan
  'Malmö FF': { primary: '#87CEEB', secondary: '#FFFFFF' },
  'AIK Stockholm': { primary: '#000000', secondary: '#FFD700' },
  'Djurgårdens IF': { primary: '#003DA5', secondary: '#E30613' },
  'Hammarby IF': { primary: '#00A651', secondary: '#FFFFFF' },
  'IFK Göteborg': { primary: '#003DA5', secondary: '#FFFFFF' },
  'IFK Norrköping': { primary: '#003DA5', secondary: '#FFFFFF' },
  'IF Elfsborg': { primary: '#FFD700', secondary: '#000000' },
  'BK Häcken': { primary: '#FFD700', secondary: '#000000' },
  'Kalmar FF': { primary: '#E30613', secondary: '#FFFFFF' },
  'IK Sirius': { primary: '#003DA5', secondary: '#000000' },
  'Mjällby AIF': { primary: '#FFD700', secondary: '#000000' },
  'Degerfors IF': { primary: '#E30613', secondary: '#FFFFFF' },
  // Norwegian Eliteserien
  'Bodø/Glimt': { primary: '#FFD700', secondary: '#000000' },
  'Molde FK': { primary: '#003DA5', secondary: '#FFFFFF' },
  'Rosenborg BK': { primary: '#FFFFFF', secondary: '#000000' },
  'Brann Bergen': { primary: '#E30613', secondary: '#FFFFFF' },
  'Vålerenga': { primary: '#003DA5', secondary: '#E30613' },
  'Lillestrøm SK': { primary: '#FFD700', secondary: '#000000' },
  'Viking FK': { primary: '#003DA5', secondary: '#FFFFFF' },
  'Tromsø': { primary: '#E30613', secondary: '#FFFFFF' },
  'HamKam': { primary: '#000000', secondary: '#FFD700' },
  'Haugesund': { primary: '#FFFFFF', secondary: '#000000' },
  'Kristiansund': { primary: '#003DA5', secondary: '#FFFFFF' },
  'Sandefjord': { primary: '#003DA5', secondary: '#FFD700' },
  'Sarpsborg 08': { primary: '#003DA5', secondary: '#FFD700' },
  'Strømsgodset': { primary: '#003DA5', secondary: '#000000' },
  'Odds BK': { primary: '#000000', secondary: '#FFFFFF' },
  // Finnish Veikkausliiga
  'HJK Helsinki': { primary: '#003DA5', secondary: '#FFFFFF' },
  'KuPS': { primary: '#FFD700', secondary: '#000000' },
  'FC Honka': { primary: '#FFD700', secondary: '#000000' },
  'FC Lahti': { primary: '#000000', secondary: '#FFFFFF' },
  'Inter Turku': { primary: '#003DA5', secondary: '#FFFFFF' },
  'AC Oulu': { primary: '#003DA5', secondary: '#FFFFFF' },
  'Ilves': { primary: '#00A651', secondary: '#FFFFFF' },
  'HIFK': { primary: '#E30613', secondary: '#FFFFFF' },
  'IFK Mariehamn': { primary: '#FFD700', secondary: '#000000' },
  'KTP': { primary: '#003DA5', secondary: '#FFD700' },
  'SJK': { primary: '#000000', secondary: '#FFFFFF' },
  'VPS': { primary: '#000000', secondary: '#FFFFFF' },
  // Eredivisie / Eerste Divisie (additional)
  'Almere City FC': { primary: '#000000', secondary: '#FFD700' },
  'Excelsior Rotterdam': { primary: '#E30613', secondary: '#000000' },
  // Saudi / MLS
  'Al-Ahli': { primary: '#00A651', secondary: '#FFFFFF' },
  'Inter Miami': { primary: '#F7B5CD', secondary: '#000000' },
  // Swiss Super League
  'Young Boys': { primary: '#FFD700', secondary: '#000000' },
  'Basel': { primary: '#E30613', secondary: '#003DA5' },
  'Servette': { primary: '#7A0026', secondary: '#FFFFFF' },
  'Lugano': { primary: '#000000', secondary: '#FFFFFF' },
  'Lausanne-Sport': { primary: '#003DA5', secondary: '#FFFFFF' },
  'Luzern': { primary: '#003DA5', secondary: '#FFFFFF' },
  'St. Gallen': { primary: '#00A651', secondary: '#FFFFFF' },
  'Zürich': { primary: '#003DA5', secondary: '#FFFFFF' },
  'Sion': { primary: '#E30613', secondary: '#FFFFFF' },
  'Yverdon-Sport': { primary: '#003DA5', secondary: '#FFD700' },
  'Grasshoppers': { primary: '#003DA5', secondary: '#FFFFFF' },
  'Winterthur': { primary: '#E30613', secondary: '#FFFFFF' },
  // Austrian Bundesliga
  'Red Bull Salzburg': { primary: '#E30613', secondary: '#FFFFFF' },
  'Sturm Graz': { primary: '#000000', secondary: '#FFFFFF' },
  'LASK': { primary: '#000000', secondary: '#FFFFFF' },
  'Rapid Wien': { primary: '#00A651', secondary: '#FFFFFF' },
  'Austria Wien': { primary: '#7A0026', secondary: '#FFFFFF' },
  'WAC': { primary: '#000000', secondary: '#FFFFFF' },
  'TSV Hartberg': { primary: '#003DA5', secondary: '#FFD700' },
  'Austria Klagenfurt': { primary: '#7A0026', secondary: '#FFFFFF' },
  'Blau-Weiß Linz': { primary: '#003DA5', secondary: '#FFFFFF' },
  'WSG Tirol': { primary: '#00A651', secondary: '#FFFFFF' },
  'SCR Altach': { primary: '#E30613', secondary: '#FFFFFF' },
  'GAK': { primary: '#E30613', secondary: '#FFFFFF' },
  // Estonian Meistriliiga
  'Flora Tallinn': { primary: '#00A651', secondary: '#FFFFFF' },
  'Levadia Tallinn': { primary: '#00A651', secondary: '#000000' },
  'Paide Linnameeskond': { primary: '#000000', secondary: '#FFD700' },
  'Nõmme Kalju': { primary: '#FFD700', secondary: '#003DA5' },
  'FC Kuressaare': { primary: '#003DA5', secondary: '#FFD700' },
  'Tallinna Kalev': { primary: '#003DA5', secondary: '#FFFFFF' },
  'Vaprus Pärnu': { primary: '#003DA5', secondary: '#FFFFFF' },
  'Harju JK Laagri': { primary: '#003DA5', secondary: '#FFD700' },
  'Tartu Tammeka': { primary: '#000000', secondary: '#FFFFFF' },
  // Latvian Virslīga
  'Riga FC': { primary: '#7A0026', secondary: '#FFFFFF' },
  'RFS': { primary: '#FFD700', secondary: '#003DA5' },
  'Valmiera FC': { primary: '#00A651', secondary: '#FFFFFF' },
  'Auda': { primary: '#003DA5', secondary: '#FFD700' },
  'Liepāja': { primary: '#003DA5', secondary: '#FFFFFF' },
  'BFC Daugavpils': { primary: '#FFD700', secondary: '#003DA5' },
  'Tukums': { primary: '#003DA5', secondary: '#FFFFFF' },
  'Jelgava': { primary: '#7A0026', secondary: '#FFFFFF' },
  'Metta': { primary: '#000000', secondary: '#FFD700' },
  'Grobiņa': { primary: '#00A651', secondary: '#FFFFFF' },
  // Hungarian NB I
  'Ferencváros': { primary: '#00A651', secondary: '#FFFFFF' },
  'Puskás Akadémia': { primary: '#003DA5', secondary: '#FFD700' },
  'Paks': { primary: '#00A651', secondary: '#FFD700' },
  'MTK Budapest': { primary: '#003DA5', secondary: '#FFFFFF' },
  'Debrecen': { primary: '#E30613', secondary: '#FFFFFF' },
  'Fehérvár': { primary: '#E30613', secondary: '#003DA5' },
  'Kisvárda': { primary: '#FFD700', secondary: '#7A0026' },
  'Diósgyőr': { primary: '#E30613', secondary: '#FFFFFF' },
  'Újpest': { primary: '#7A0026', secondary: '#FFFFFF' },
  'Győri ETO': { primary: '#00A651', secondary: '#FFFFFF' },
  'Nyíregyháza': { primary: '#FFD700', secondary: '#003DA5' },
  'ZTE': { primary: '#003DA5', secondary: '#FFFFFF' },

  // ===== Bulgaria – Parva Liga =====
  'Ludogorets Razgrad': { primary: '#006633', secondary: '#FFFFFF' },
  'CSKA Sofia': { primary: '#A2231D', secondary: '#FFFFFF' },
  'Levski Sofia': { primary: '#003DA5', secondary: '#FFFFFF' },
  'Slavia Sofia': { primary: '#FFFFFF', secondary: '#000000' },
  'Lokomotiv Plovdiv': { primary: '#000000', secondary: '#1A75CF' },
  'Botev Plovdiv': { primary: '#FFD700', secondary: '#000000' },
  'Cherno More': { primary: '#0A2A52', secondary: '#FFFFFF' },
  'Arda Kardzhali': { primary: '#A2231D', secondary: '#FFFFFF' },
  'Hebar Pazardzhik': { primary: '#1F8A4C', secondary: '#FFFFFF' },
  'Krumovgrad': { primary: '#A2231D', secondary: '#FFD700' },
  'Beroe': { primary: '#1F8A4C', secondary: '#FFFFFF' },
  'Septemvri Sofia': { primary: '#A2231D', secondary: '#FFFFFF' },
  'Botev Vratsa': { primary: '#1F8A4C', secondary: '#FFFFFF' },
  'CSKA 1948': { primary: '#A2231D', secondary: '#003DA5' },

  // ===== Romania – SuperLiga =====
  'FCSB': { primary: '#A2231D', secondary: '#003DA5' },
  'CFR Cluj': { primary: '#7A0026', secondary: '#FFFFFF' },
  'Universitatea Craiova': { primary: '#003DA5', secondary: '#FFFFFF' },
  'Rapid București': { primary: '#7A0026', secondary: '#FFFFFF' },
  'Sepsi OSK': { primary: '#1F8A4C', secondary: '#FFFFFF' },
  'Farul Constanța': { primary: '#003DA5', secondary: '#FFFFFF' },
  'Universitatea Cluj': { primary: '#000000', secondary: '#FFFFFF' },
  'Petrolul Ploiești': { primary: '#FFD700', secondary: '#003DA5' },
  'Hermannstadt': { primary: '#A2231D', secondary: '#000000' },
  'Dinamo București': { primary: '#A2231D', secondary: '#FFFFFF' },
  'UTA Arad': { primary: '#A2231D', secondary: '#FFFFFF' },
  'Botoșani': { primary: '#A2231D', secondary: '#FFFFFF' },
  'Oțelul Galați': { primary: '#A2231D', secondary: '#FFD700' },
  'Poli Iași': { primary: '#003DA5', secondary: '#FFD700' },
};

function clubHue(name: string): number {
  const normalized = name
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ');
  let h = 0;
  for (let i = 0; i < normalized.length; i++) h = (h * 31 + normalized.charCodeAt(i)) >>> 0;
  return h % 360;
}

interface ClubBadgeProps {
  club: string;
  className?: string;
}

export function ClubBadge({ club, className }: ClubBadgeProps) {
  const colors = CLUB_COLORS[club];

  if (!colors) {
    const hue = clubHue(club || '');
    const primary = `hsl(${hue} 60% 45%)`;
    const secondary = `hsl(${(hue + 35) % 360} 60% 55%)`;
    return (
      <span
        className={cn('inline-block h-3.5 w-3.5 rounded-full shrink-0 ring-1 ring-black/10', className)}
        style={{ background: `linear-gradient(135deg, ${primary} 50%, ${secondary} 50%)` }}
        title={club}
      />
    );
  }

  return (
    <span
      className={cn('inline-block h-3.5 w-3.5 rounded-full shrink-0 ring-1 ring-black/10', className)}
      style={{
        background: `linear-gradient(135deg, ${colors.primary} 50%, ${colors.secondary} 50%)`,
      }}
      title={club}
    />
  );
}
